// State
import state from "@/vue/club-advantages/state/state";

// Classes
import { InfantClub } from "@/vue/club-advantages/classes/InfantClub";

function buildInfantClubs(): void {
	validateClubs();
	const clubs: InfantClub[] = window.lihe.clubs;
	clubs.forEach((club) => {
		state.infantClubs.push(
			new InfantClub(
				club.clubName,
				club.minAndMaxAge,
				club.activitiesDescription
			)
		);
	});
}

function validateClubs(): void {
	const clubs: InfantClub[] = window.lihe.clubs;
	if (!clubs) throw new Error("clubs are mandatory in buildInfantClubs");
	for (const club of clubs) {
		if (!club.activitiesDescription) {
			state.hideClubs = true;
		}
	}
}

export default buildInfantClubs;
